<div class="return-packaging-cart-line">
  <div class="d-flex fw-bold mt-3 mb-2 align-items-center justify-content-between">
    <span>{{ titleKey() | translate }}</span>

    @if (price()) {
      <span>{{ price() | currencyFormat: currency() }}</span>
    }
  </div>

  <div class="mb-2 font-sm">
    {{ details().scheduledDate | i18nDate : 'dddd D.' }}
    <span class="text-lowercase">
      {{ details().scheduledDate | i18nDate : 'MMM' }}
    </span>
    {{ details().scheduledTime }}
  </div>

  @if (!isSelfReturn() && details().pickupAddress) {
    <div class="mt-4 mb-3 font-sm">
      <div>{{ details().pickupAddress }}</div>
      <div>{{ details().pickupPostNumber }}</div>
    </div>
  }

  @if (showEdit()) {
    <div class="my-3 font-sm">
      <button class="btn btn-text-primary font-sm fw-bold" (click)="onEdit.emit()">
        {{ 'cart.returnPackaging.edit' | translate }}
      </button>
    </div>
  }
</div>
